import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import categoryApi, { CategoryReqBody } from "../api/categories";
import { ICategory, ICategoryType, IHobby, ISkill, ISubject } from "@wot/typings";

interface IInitalState {
  categories: ICategory<ISubject>[] | ICategory<IHobby>[] | ICategory<ISkill>[];
  error: string;
  loading: boolean;
}

const initalState: IInitalState = {
  categories: [],
  error: "",
  loading: false,
};

export const addCategories = createAsyncThunk(
  "add",
  async (
    { data }: { data: CategoryReqBody[] },
    { fulfillWithValue, rejectWithValue }
  ) => {
    const result = await categoryApi.addCategories(data);
    console.log(result);
    fulfillWithValue(result);
  }
);

export const getCategories = createAsyncThunk(
  "add",
  async (type: ICategoryType, { fulfillWithValue, rejectWithValue }) => {
    const result = await categoryApi.getCategories(type);
    console.log(result);
    fulfillWithValue(result);
  }
);

const categorySlice = createSlice({
  name: "category Reducer",
  initialState: initalState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(addCategories.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(addCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      // @ts-ignore
      state.categories = action.payload;
    });
    builder.addCase(addCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = "Something went wrong";
    });

    // builder.addCase(getCategories.pending, (state, action) => {
    //   state.loading = true;
    //   state.error = "";
    // })
    // builder.addCase(getCategories.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.error = "";
    //   // @ts-ignore
    //   state.categories = [...action.payload];
    // })
    // builder.addCase(getCategories.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = "Something went wrong";
    // })
  },
});

export const { } = categorySlice.actions;

export default categorySlice.reducer;
